import React, { useState, useEffect } from "react";
import { Card, Row, Col, Tag } from "antd";
import moment from "moment";

// Components
import ThreeFigure from "../../components/three-figure";
import Table from "../../components/table";
import Search from "../../components/table/search";
import SearchDates from "../../components/table/searchDates";
import RenderFigureData from "../../components/render-figure-data";

// Hooks
import useArticles from "../../hooks/useArticles";

import { figurenames, webEntity } from "../../constants";

// Styles
import { ThreeBox } from "./styles";

//import multilanguage library
import { useTranslation } from "react-i18next";

import { GET_ARTICLES } from "../../operations/queries/articles";

import { useQuery } from "@apollo/react-hooks";

const SelectionArticle = ({ handleChangeArticle, article }) => {
  const [listOfArticles, setListOfArticles] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [selectedRowKey, setSelectedRowKey] = useState([]);

  const { articleData } = useArticles();

  //To translate text
  const { t } = useTranslation();

  const { data, networkStatus } = useQuery(GET_ARTICLES(webEntity), {
    notifyOnNetworkStatusChange: true,
  });
  //if (networkStatus === 4) console.log("Refetching!");
  //if (loading) console.log("loaging");
  //if (error) console.log(`Error! ${error}`);

  useEffect(() => {
    if (data && data.articles) {
      setListOfArticles(data.articles);
      data.articles[0] && getDataOnRow(data.articles[0]);
    }
  }, [data]);

  useEffect(() => {
    if (handleChangeArticle && selectedArticle) handleChangeArticle(selectedArticle);
  }, [selectedArticle]);

  /*useEffect(() => {
    const normalized = desings.map((article) => {
      return {
        key: article.id,
        ...article,
      };
    });

    let selected = article ? normalized.findIndex((art) => art.id === article.id) : 0;

    //normalized && setListOfArticles(normalized);
    if (normalized && normalized[selected]) {
      setSelectedArticle(normalized[selected]);
      setSelectedRowKey([normalized[selected].key]);
    }
  }, [desings]);*/

  const columns = [
    {
      title: t("table.header.name"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
      ...Search("name"),
    },
    {
      title: t("table.header.geometry"),
      dataIndex: "id_article_type.name",
      key: "id_article_type.name",
      sorter: (a, b) => a.id_article_type.name.localeCompare(b.id_article_type.name),
      //...Search("selected_figure"),
      filters: [
        { text: t("geometry.cylinder"), value: "cylinder" },
        { text: t("geometry.rhomboid"), value: "rhomboid" },
        { text: t("geometry.torus"), value: "torus" },
        { text: t("geometry.rectangle"), value: "rectangle" },
      ],
      onFilter: (value, record) => record.id_article_type.name.toLowerCase().includes(value),
      render: (value) => {
        if (value) return t("geometry." + value.toLowerCase());
        else return "";
      },
    },
    {
      title: t("table.header.type"),
      dataIndex: "is_prototype",
      key: "is_prototype",
      width: 100,
      render: (isPrototype) => (isPrototype ? t("labels.prototype") : t("labels.catalogue")),
      filters: [
        { text: t("labels.prototype"), value: true },
        { text: t("labels.catalogue"), value: false },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.is_prototype === value,
    },
    {
      title: t("table.header.article_date"),
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      ...SearchDates("date"),
      render: (date) => moment(date).format("DD/MM/YYYY HH:mm:ss"),
    },
  ];

  //Selected row
  async function getDataOnRow(row) {
    const response = await articleData(row.id_article);
    if (!response) return;
    let article_type = row.id_article_type.name.toLowerCase();

    let figure = {
      name: article_type,
    };

    let values = {};
    figurenames[article_type].forEach((data) => {
      let prop = response.find((el) => el.tag.trim() === data.key);
      values[data.key] = prop && prop.value && parseInt(prop.value);
    });

    response.forEach((el) => {
      if (!values[el.tag.trim()]) {
        row[el.tag.trim()] = parseInt(el.value);
      }
    });

    figure.values = values;
    row.figure = figure;

    setSelectedRowKey([row.id_article]);
    setSelectedArticle(row);
  }

  // rowSelection objects indicates the need for row selection
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      //setSelectedArticle(desings.find((obj) => obj.id === record.id));
      getDataOnRow(record);
    },
    type: "radio",
  };

  const clickRow = (row) => {
    //setSelectedRowKey([row.key]);
    //setSelectedArticle(desings.find((obj) => obj.id === row.id));
    getDataOnRow(row);
  };

  return (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col xl={16} lg={24}>
        <Table rowKey="id_article" data={listOfArticles} columns={columns} rowSelection={rowSelection} onClick={() => clickRow} />
      </Col>
      <Col xl={8} lg={24}>
        <Card
          title={selectedArticle && selectedArticle.articleName}
          extra={
            selectedArticle && selectedArticle.is_prototype ? (
              <Tag color="magenta">{t("labels.prototype")}</Tag>
            ) : (
              <Tag color="blue">{t("labels.catalogue")}</Tag>
            )
          }
          cover={
            selectedArticle && (
              <ThreeBox>
                <ThreeFigure figureData={selectedArticle && selectedArticle.figure} />
              </ThreeBox>
            )
          }
        >
          <RenderFigureData selectedArticle={selectedArticle} />
        </Card>
      </Col>
    </Row>
  );
};

export default SelectionArticle;
